export default __webpack_public_path__ + "static/media/webcomponents.51081c7a.svg";